// src/api/modulesApi.js
import axios from "axios";

export const updateComType = async (id, updatedData) => {
  try {
    const response = await axios.put(`http://localhost:8080/webnet-hms/api/company-type/${id}`, updatedData);
    console.log(response.data);
  } catch (error) {
    window.alert("Error updating Company Type:", error);
    throw error;
  }
};
